import React from 'react';
import { Box, Paper, Typography, Button, Container } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useCookieConsent } from '../../contexts/CookieConsentContext';

const CookieConsentBanner = () => {
  const { showBanner, hasConsent, acceptCookies, rejectCookies, closeConsentSettings } = useCookieConsent();

  if (!showBanner) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      }}
    >
      <Container maxWidth="lg">
        <Paper
          elevation={0}
          sx={{
            backgroundColor: 'transparent',
            p: { xs: 2, sm: 3 },
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'stretch', sm: 'center' },
            gap: 2,
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h6"
              sx={{
                color: 'white',
                fontWeight: 600,
                mb: 1,
                fontSize: { xs: '1rem', sm: '1.1rem' },
              }}
            >
              Cookie-instellingen
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: { xs: '0.85rem', sm: '0.95rem' },
                lineHeight: 1.6,
              }}
            >
              Wij gebruiken alleen optionele analysetools nadat u daarvoor toestemming geeft.
              Met Google Analytics en Microsoft Clarity meten we hoe bezoekers de website gebruiken,
              zodat we pagina&apos;s en contactmomenten kunnen verbeteren. Lees meer in ons{" "}
              <Typography
                component={RouterLink}
                to="/privacy"
                variant="body2"
                sx={{
                  color: 'white',
                  textDecoration: 'underline',
                  fontWeight: 600,
                }}
              >
                privacy- en cookiebeleid
              </Typography>
              .
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              gap: 1.5,
              flexDirection: { xs: 'column', sm: 'row' },
              flexShrink: 0,
            }}
          >
            {hasConsent !== null ? (
              <Button
                variant="text"
                onClick={closeConsentSettings}
                sx={{
                  color: 'rgba(255,255,255,0.85)',
                  px: 2,
                  py: 1,
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                  },
                }}
              >
                Sluiten
              </Button>
            ) : null}
            <Button
              variant="outlined"
              onClick={rejectCookies}
              sx={{
                color: 'white',
                borderColor: 'rgba(255, 255, 255, 0.3)',
                px: 3,
                py: 1,
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                },
              }}
            >
              Alleen noodzakelijk
            </Button>
            <Button
              variant="contained"
              onClick={acceptCookies}
              sx={{
                backgroundColor: '#4CAF50',
                color: 'white',
                px: 3,
                py: 1,
                fontWeight: 600,
                '&:hover': {
                  backgroundColor: '#45a049',
                },
              }}
            >
              Accepteren
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default CookieConsentBanner;
